module.exports = __webpack_public_path__ + "img/emoji/bebe.538cf3c9ff18d1d777f17d2c8a7a82ef.png";